export const REST_API_PATH  = import.meta.env.VITE_APP_REST_API_PATH
export const PROXY_REST_API_PATH = `${ REST_API_PATH }/gql-proxy`
export const GRAPHQL_API_PATH = import.meta.env.VITE_APP_GQL_API_PATH
